import { render } from "./create.vue?vue&type=template&id=072be39c"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
script.render = render

export default script